import React from "react";
import { CXContext } from "./cxContext";
import * as dc from "dc";
import * as d3 from 'd3';
import { rhythm } from "../utils/typography.js";
import { css } from "glamor";

let metric = "Count";
const commasFormatter = (num) => {
  return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)//d3.format(",.0f");
}

const Options = props => {
  const options = ["# of Conversations", "Total Waiting Time", "Average  Waiting Time", "Total Conversation Time", "Average Conversation Time"];
  //this.handleChange = this.handleChange.bind(this);
  const listOptions = options.map((option, i) =>
    <option key= {i} value={option} >{option}</option>
  );
  const style = css({
    marginRight: rhythm(0.2),
    marginTop: rhythm(0.1),
    padding: rhythm(0.1),
    display: "inline",
    cursor:'pointer',
    float:'right',
    fontSize: '12px',
    maxWidth: '160px'
  });

  return (
    <select {...style}
      onChange={ (e) => {
        metric =  e.target.value;
        //console.log(props.chartType);
        if(props.chartType != "heatmap") {
          const val = props.chart.valueAccessor(function(p) {
            //console.log('metric '+metric);
            if( metric == '# of Conversations') return p.value.count;
            else if( metric == 'Total Waiting Time') return p.value.total;
            else if(metric == 'Average  Waiting Time') return p.value.avg;
            else if(metric == 'Total Conversation Time') return p.value.tot_conversation_time;
            else if(metric == 'Average Conversation Time') return p.value.avg_conversation_time;
          });
          if(props.chartType != 'rowchart'){
            if( metric != '# of Conversations' ){
              props.chart.yAxis().tickFormat(function(d) { return commasFormatter(d) + ' s'; }).ticks(6)
            } else props.chart.yAxis().tickFormat(function(d) { return commasFormatter(d) ; }).ticks(6)
          } else {
            if( metric != '# of Conversations' ){
              props.chart.xAxis().tickFormat(function(d) { return commasFormatter(d) + ' s'; }).ticks(5);
              //props.chart.title(function(d) { return d3.format(",.2r")(d.value) + ' s'; });
            } else props.chart.xAxis().tickFormat(function(d) { return commasFormatter(d) ; }).ticks(5)
          }
        } else {
          props.chart.colorAccessor(function(p) {
            //console.log('metric '+metric);
            if( metric == '# of Conversations') return p.value.count;
            else if( metric == 'Total Waiting Time') return p.value.total;
            else if(metric == 'Average  Waiting Time') return p.value.avg;
            else if(metric == 'Total Conversation Time') return p.value.tot_conversation_time;
            else if(metric == 'Average Conversation Time') return p.value.avg_conversation_time;
          });
          props.chart.calculateColorDomain();
        }

        props.chart.redraw();
        //dc.calculateColorDomain();
        //dc.redrawAll();
      }}
      >
      {listOptions}
    </select>
  )
}

const ResetButton = props => {
  const style = css({
    fontSize: "10px",
    marginRight: rhythm(-0.02),
    marginTop: rhythm(0.2),
    padding: rhythm(0.2),
    paddingLeft: rhythm(0.2),
    display: "inline",
    cursor:'pointer',
    float:'right',
    '&:hover':{
        background: "#ddd",
    }
  });
  return (
    <span
      {...style}
      onClick={() => {
        props.chart.filterAll();
        dc.redrawAll();
      }}
    >
      reset
    </span>
  );
};
export const ChartTemplate = props => {
    /*
    We render the dc chart using an effect. We want to pass the chart as a prop after the dc call,
    but there is nothing by default to trigger a re-render and the prop, by default would be undefined.
    To solve this, we hold a state key and increment it after the effect ran.
    By passing the key to the parent div, we get a rerender once the chart is defined.
    */
  const context = React.useContext(CXContext);
  const [chart,updateChart] = React.useState(null);
  const ndx = context.ndx;
  const calc = metric//context.calc;
  const div = React.useRef(null);


  React.useEffect(() => {
    const newChart = props.chartFunction(div.current, ndx); // chartfunction takes the ref and does something with it
    //const metric = props.chartVizFunc(div.current, metric)

    newChart.render();
    updateChart(newChart);
  },1); {/*Run this exactly once */}

  const chartStyles  = css({
    width:'100%',
    height:'auto',
    boxSizing:'border-box',
    paddingTop: rhythm(.5),
    paddingRight: rhythm(.01),
    paddingBottom: rhythm(.01),
    paddingLeft: rhythm(1),
    '& label':{
      textTransform:'capitalize',
      //textDecoration:'underline',
    }

  })
  return (
    <div
      ref={div}
      {...chartStyles}
    >
     {!props.noreset ?
     <ResetButton chart={chart} /> : ''}
     <label>{props.title}</label>
     <Options chart={chart} chartType={props.type}/>
    </div>
  );
};
